import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import App from './App/index';
import * as serviceWorker from './serviceWorker';
import { store } from './store/store';
import config from './config';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import 'devextreme/dist/css/dx.light.css';
// import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import './assets/scss/style.scss';
import './i18n';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Loader from './App/layout/Loader';
const app = (
    <React.Suspense fallback={<Loader />}>
        {/* <React.StrictMode> */}
        <Provider store={store}>
            <HashRouter basename={config.basename}>
                <App />
            </HashRouter>
        </Provider>
        {/* </React.StrictMode> */}
    </React.Suspense>
);
ReactDOM.render(app, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
